import * as React from "react";
import user1 from "assets/images/entry-user1.png";
import user2 from "assets/images/entry-user2.png";
import user3 from "assets/images/entry-user3.png";
import user4 from "assets/images/entry-user4.png";
import user5 from "assets/images/entry-user5.png";
import chartRadar1 from "assets/images/chart-radar1-sm.svg";
import chartRadar2 from "assets/images/chart-radar2-sm.svg";
import chartRadar3 from "assets/images/chart-radar3-sm.svg";
import chartRadar4 from "assets/images/chart-radar4-sm.svg";
import chartRadar5 from "assets/images/chart-radar5-sm.svg";
import chartRadar1En from "assets/images/chart-radar1-sm-en.svg";
import chartRadar2En from "assets/images/chart-radar2-sm-en.svg";
import chartRadar3En from "assets/images/chart-radar3-sm-en.svg";
import chartRadar4En from "assets/images/chart-radar4-sm-en.svg";
import chartRadar5En from "assets/images/chart-radar5-sm-en.svg";
import bgPreview from "assets/images/bg-preview-sm.png";
import EntryMobile from "component/card/EntryMobile";
import avatar1 from "assets/images/avatar1.glb";
import avatar2 from "assets/images/avatar2.glb";
import avatar3 from "assets/images/avatar3.glb";
import avatar4 from "assets/images/avatar4.glb";
import avatar5 from "assets/images/avatar5.glb";
import Video from "routes/Video";

function Preview(props) {
  const { lang } = props;
  const isEn = lang === "en" ? true : false;
  const entries = [
    {
      entryNumber: "entry No1",
      name: isEn ? "Kotora" : "小虎",
      image: user1,
      title: "City Pop TOKYO #518",
      owner: "@tora_0515",
      graph: lang === "en" ? chartRadar1En : chartRadar1,
      preview3d: avatar1,
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/01_Tora_Highres_w_logo.mp4",
    },
    {
      entryNumber: "entry No2",
      name: isEn ? "Suzu" : "すず",
      image: user2,
      title: "City Pop TOKYO #184",
      owner: "@suzu_chan1984",
      graph: lang === "en" ? chartRadar2En : chartRadar2,
      preview3d: avatar2,
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/02_Suzu_Highres_w_logo.mp4",
    },
    {
      entryNumber: "entry No3",
      name: isEn ? "Shinya" : "しんや",
      image: user3,
      title: "City Pop TOKYO #303",
      owner: "@Milford202111",
      graph: lang === "en" ? chartRadar3En : chartRadar3,
      preview3d: avatar3,
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/03_Shinya_Highres_w_logo.mp4",
    },
    {
      entryNumber: "entry No4",
      name: isEn ? "Akane Naniwa" : "浪花明音　アカンネ〜",
      image: user4,
      title: "City Pop TOKYO #327",
      owner: "@jyaburou",
      graph: lang === "en" ? chartRadar4En : chartRadar4,
      preview3d: avatar4,
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/04_Akane_Highres_w_logo.mp4",
    },
    {
      entryNumber: "entry No5",
      name: isEn ? "ANGEL" : "あんじ",
      image: user5,
      title: "City Pop TOKYO #326",
      owner: "@ojami1001",
      graph: lang === "en" ? chartRadar5En : chartRadar5,
      preview3d: avatar5,
      video:
        "https://asobi-voting-assets-prod.s3.ap-northeast-1.amazonaws.com/video/05_ANGEL_Highres_w_logo.mp4",
    },
  ];

  return (
    <>
      {entries.map((entry, index) => (
        <>
          <section
            id={entry?.name}
            style={{
              background: `url(${bgPreview})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <EntryMobile {...entry} />

            <section className="flex flex-col justify-center m-6">
              <Video video={entry?.video} lang={lang} />
            </section>
          </section>
        </>
      ))}
    </>
  );
}

export default Preview;
